import { render, staticRenderFns } from "./dialogSelGoodsMultiple.vue?vue&type=template&id=dd52aa22&scoped=true"
import script from "./dialogSelGoodsMultiple.vue?vue&type=script&lang=js"
export * from "./dialogSelGoodsMultiple.vue?vue&type=script&lang=js"
import style0 from "./dialogSelGoodsMultiple.vue?vue&type=style&index=0&id=dd52aa22&prod&lang=less&scoped=true"
import style1 from "./dialogSelGoodsMultiple.vue?vue&type=style&index=1&id=dd52aa22&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd52aa22",
  null
  
)

export default component.exports